import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListIsEmailAddressVerifiedCell } from './emsp-bo-emsp-user-list-is-email-address-verified.cell';
import { EmspBoEmspUserListIsEmailAddressVerifiedHeader } from './emsp-bo-emsp-user-list-is-email-address-verified.header';

export const EmspBoEmspUserListIsEmailAddressVerifiedColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['isEmailAddressVerified']
> = {
  enableSorting: false,
  header: EmspBoEmspUserListIsEmailAddressVerifiedHeader,
  cell: EmspBoEmspUserListIsEmailAddressVerifiedCell,
};
